import React from "react";
import { Spin } from "antd";
import CustomSignIn from "../CustomSignIn";
import CustomSignUp from "../CustomSignUp";
import CustomForgotPassword from "../CustomForgotPassword";
import CustomForgotPasswordVerification from "../CustomForgotPasswordVerification";
import Main from "../Main";
import { GlobalContext } from "../../context.global";
import "./styles.css";

interface IAuthWrapperState {
  email: string;
}

interface IAuthWrapperProps {
  authState: string;
  onStateChange: (state: string, e: any) => void;
}

class AuthWrapper extends React.Component<IAuthWrapperProps, IAuthWrapperState> {
  static defaultProps = {
    authState: "loading",
    onStateChange: (state: string, e: any) => {
      console.log({ state, e });
    }
  };

  static contextType = GlobalContext;
  context!: React.ContextType<typeof GlobalContext>;

  state: IAuthWrapperState = {
    email: ""
  };

  handleUpdateEmail = (email: string) => this.setState({ email });

  handleOnAuthChange = (state: string, e: any) => {
    this.props.onStateChange(state, e);
    if (state === "signedIn") {
      this.context.getUserAttributes();
    }
  };

  render() {
    switch (this.props.authState) {
      case "loading":
        return (
          <div className="LoadingApp-Container">
            <div className="LoadingApp-Card">
              <Spin size="large" />
            </div>
          </div>
        );
      case "signedIn":
        return <Main />;
      case "signUp":
        return <CustomSignUp onAuthChange={this.handleOnAuthChange} />;
      case "forgotPassword":
        return (
          <CustomForgotPassword
            onAuthChange={this.handleOnAuthChange}
            onUpdateEmail={this.handleUpdateEmail}
          />
        );
      case "forgotPasswordVerification":
        return (
          <CustomForgotPasswordVerification
            onAuthChange={this.handleOnAuthChange}
            email={this.state.email}
          />
        );
      default:
        return (
          <CustomSignIn
            onAuthChange={this.handleOnAuthChange}
            onUpdateEmail={this.handleUpdateEmail}
          />
        );
    }
  }
}

export default AuthWrapper;
